import { useCallback, useEffect, useState } from 'react'
import Table from 'src/components/table/table'
import Filters from 'src/components/table/filters'

import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import {
  getPurchasedPrintables,
  deletePurchasedPrintables,
} from 'src/services/api.service'
import DownloadRow from './components/download-row'

const statusOptions = [
  // { value:  "draft", label: 'Draft' },
  // { value:  "in review", label: 'In review' },
  { value: 'Active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  // { value:  "rejected", label: 'Rejected' },
]

export const Downloads = () => {
  const { user, setViewStates } = useAuth()
  const { showErrorHelper, showConfirm } = useNotification()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    items: [],
    count: 0,
    pageCount: 1,
  })
  const [filter, setFilter] = useState({
    subject_id: null,
    grade_id: null,
    status: null,
    period: null,
    query: '',
  })
  const [lastFetchParams, setLastFetchParams] = useState({})

  const [step, setStep] = useState(0)

  useEffect(() => {
    setStep(user?.view_states?.downloadStep || 1)
  }, user?.view_states?.downloadStep)

  const fetchData = useCallback(async ({ pageSize, pageIndex, filterData }) => {
    try {
      setLastFetchParams({ pageSize, pageIndex, filterData })
      setLoading(true)
      const response = await getPurchasedPrintables({
        ...filterData,
        page: pageIndex + 1,
        perPage: pageSize,
      })
      setData({
        items: response.data.items,
        count: response.data.total,
        pageCount: Math.ceil(response.data.total / pageSize),
      })
    } catch (error) {
      showErrorHelper(error)
    } finally {
      setLoading(false)
    }
  }, [])

  const handleDeleteClick = (item) => (e) => {
    e.preventDefault()
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to delete the ${item.title}?`,
      actions: {
        onOk: async () => {
          await deletePurchasedPrintables(item.id)
          fetchData(lastFetchParams)
        },
      },
    })
  }

  const handleSearchPrintables = () => {
    setViewStates({ downloadStep: 2 })
    setStep(2)
  }

  return (
    <>
      <div className="sectionHb-top">
        <h2 className="sectionHb-title">Downloads</h2>
      </div>

      {step === 1 && (
        <div className="sectionHb-block dashboardHb">
          <div className="sectionHb-block__wrap">
            <h2 className="sectionHb-title">
              It’s time to get printable worksheets!
            </h2>
            <div className="dashboardHb-img">
              <img src="/account/img/dashboard/img-3.svg" alt="" />
            </div>
            <p className="dashboardHb-small">
              We offer thousands of FREE or low priced printable worksheets, for
              children of all ages so they will never feel the lack of
              excitement about learning and improving their skills.
            </p>
            <a
              onClick={handleSearchPrintables}
              target="_blank"
              rel="noreferrer"
              href={`${process.env.REACT_APP_API_HOST}/printable-worksheets`}
              className="primary-btn primary-btn__big"
            >
              <i className="hb-ico plus-ico-white" />
              Search printables
            </a>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="sectionHb-block purchaseHb">
          <div className="sectionHb-block__wrap">
            <Filters
              buttonComponent={
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${process.env.REACT_APP_API_HOST}/printable-worksheets`}
                  className="primary-btn primary-btn__big"
                  style={{ padding: '7px 0 7px 0', textAlign: 'center' }}
                >
                  Search printables
                </a>
              }
              filter={filter}
              setFilter={setFilter}
              status={{
                options: statusOptions,
              }}
            />

            <div className="purchaseHb-table purchaseHb-table__second purchaseHb-table__green">
              <div className="purchaseHb-table__row purchaseHb-table__top">
                <div className="purchaseHb-table__col purchaseHb-table__col-1">
                  Product
                </div>
                <div className="purchaseHb-table__col purchaseHb-table__col-2">
                  Price
                </div>
                <div className="purchaseHb-table__col purchaseHb-table__col-3">
                  Data
                </div>
                <div className="purchaseHb-table__col purchaseHb-table__col-5">
                  Action
                </div>
              </div>
              <Table
                fetchData={fetchData}
                data={data.items}
                pageCount={data.pageCount}
                filter={filter}
                loading={loading}
                rowComponent={(item) => (
                  <DownloadRow
                    item={item}
                    onDelete={handleDeleteClick(item)}
                    onPrint={() => {}}
                    onCopy={() => {}}
                  />
                )}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
